import React from 'react';
import cn from 'classnames';

import styles from './Tips.scss';

const Tips = () => (
  <div className={cn('row')}>
    <div className={cn('col s12', styles.sportsWeSupport)}>

      <div className={styles.darkHeader}>SENIOR FOOTBALL RECRUITING TIPS:</div>
      <div className={styles.desc}>
        <div className={styles.redDot} />MyRecruitBoard is the ONLY service that scientifically
          matches you to every football college in America.<br />
        <div className={styles.redDot} />Don&apos;t pay an expensive third-party
          scout to evaluate and
          ultimately lessen your opportunities. Don&apos;t be fooled by &quot;Free to Signup&quot;
          recruiting services who only want to call your family and scare them
          into paying hundreds or even worse thousands of dollars.<br />
        <div className={styles.redDot} />It&apos;s never too late, MyRecruitboard can still get
          you what you need and where you want to be. Join NOW! <br />
        <div className={styles.redDot} />Attend one day camps to get the most exposure. <br />
        <div className={styles.redDot} />Video (highlights and whole game). <br />
        <div className={styles.redDot} />Choose a university that offers you the best environment
          for athletic, academic and personal development.<br />
        <div className={styles.redDot} />Take the SAT or ACT (retake if needed).<br />
        <div className={styles.redDot} />Register with the NAIA & NCAA Eligibility Center.<br />
        <div className={styles.redDot} />Use MyRecruitBoard to get National Exposure.<br />
      </div>

      <div className={styles.darkHeader}>JUNIOR FOOTBALL RECRUITING TIPS:</div>
      <div className={styles.desc}>
        <div className={styles.redDot} />MyRecruitBoard is the ONLY service that scientifically
            matches you to every football college in America. <br />
        <div className={styles.redDot} />Don&apos;t pay an expensive
          third-party scout to evaluate and
            ultimately lessen your opportunities. Don&apos;t be fooled by &quot;Free to Signup&quot;
            recruiting services who only want to call your family and scare them
            into paying hundreds or even worse thousands of dollars.<br />
        <div className={styles.redDot} />You need exposure now!<br />
        <div className={styles.redDot} />Almost all talented players in your junior class has
            been discovered by college coaches. <br />
        <div className={styles.redDot} />Contact every college you can realistically play at.<br />
        <div className={styles.redDot} />Register with the NAIA & NCAA Eligibility Center. <br />
        <div className={styles.redDot} />Video (highlights and game).<br />
        <div className={styles.redDot} />Attend camps that college coaches
          invite you to from MyRecruitBoard.<br />
        <div className={styles.redDot} />Take the SAT or ACT (retake if needed).<br />
      </div>
      <div className={styles.darkHeader}>SOPHOMORE FOOTBALL RECRUITING TIPS:</div>
      <div className={styles.desc}>
        <div className={styles.redDot} />MyRecruitBoard is the ONLY service
          that scientifically matches you to
          every football college in America.<br />
        <div className={styles.redDot} />Don&apos;t pay an expensive third-party scout
          to evaluate and ultimately lessen your
          opportunities. Don&apos;t be fooled by &quot;Free to Signup&quot;
          recruiting services who only want to call your family and scare
          them into paying hundreds or even worse thousands of dollars.<br />
        <div className={styles.redDot} />80% of Div 1 athletes have been discovered
          by their Sophomore year.<br />
        <div className={styles.redDot} />Keep your profile up-to-date.<br />
        <div className={styles.redDot} />Work on improving your biometric ratings.<br />
        <div className={styles.redDot} />Keep contacting coaches and colleges.<br />
        <div className={styles.redDot} />Video (highlights and game).<br />
        <div className={styles.redDot} />Attend camps that college coaches
          invite you to from MyRecruitBoard.<br />
      </div>

      <div className={styles.darkHeader}>FRESHMAN & MIDDLE SCHOOL FOOTBALL RECRUITING TIPS:</div>
      <div className={styles.desc}>
        <div className={styles.redDot} />MyRecruitBoard is the ONLY service that scientifically
            matches you to every football college in America.<br />
        <div className={styles.redDot} />Don&apos;t pay an expensive third-party scout to
            evaluate and ultimately lessen your opportunities.
            Don&apos;t be fooled by &quot;Free to Signup&quot; recruiting services who
            only want to call your family and scare them into paying
            hundreds or even worse thousands of dollars. <br />
        <div className={styles.redDot} />Join MyRecruitboard. <br />
        <div className={styles.redDot} />Start contacting coaches and schools through
          your MyRecruitboard profile. <br />
          Share your video and biometrics with hundreds of coaches. <br />
        <div className={styles.redDot} />Start contacting coaches and schools through your
          MyRecruitboard profile. <br />
          Attend camps that college coaches invite you to from MyRecruitBoard. <br />
      </div>


      <div className={styles.darkHeader}>JUCO & COLLEGE TRANSFER FOOTBALL RECRUITING TIPS:</div>
      <div className={styles.desc}>
        <div className={styles.redDot} />MyRecruitBoard is the ONLY service
          that scientifically matches
            you to every football college in America.<br />
        <div className={styles.redDot} />Don&apos;t pay an expensive third-party scout to
            evaluate and ultimately lessen your opportunities.
            Don&apos;t be fooled by &quot;Free to Signup&quot; recruiting
            services who only want to call your family and scare them into
            paying hundreds or even worse thousands of dollars.<br />
        <div className={styles.redDot} />It&apos;s important to get your video seen early in your
            JUCO season. JUCO Signing Day is earlier than high school
            Signing Day. If you wait too long you risk having to play at a lower division.<br />
        <div className={styles.redDot} />Typically D1 colleges only offer one or two
          JUCO players per year. It is VERY competitive! <br />
      </div>
    </div>
  </div>
);


export default Tips;



// WEBPACK FOOTER //
// ./src/components/RecruitingTips/Tips.js